/* eslint-disable no-script-url */
/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useEffect, useState } from "react";
import {
  Button,
  IconButton,
  TextField,
} from "@mui/material";

import { useLocation, useNavigate } from "react-router-dom";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import MainContainer from "../../layout/MainContainer";
import {
  useEventRefundMutation,
  useLazyGetCancelledOfferMembersQuery,
} from "../../service/offer";
import { showError, showToast } from "../../constants/toasts";
import { CancelledMemberType } from "../../types/General";
import Loader from "../../constants/Loader";

const Userlist = () => {
  const location = useLocation();
  const { state } = location;
  const offerId = state?.offerId || "";
  const navigate = useNavigate();

  const [eventRefundApi] = useEventRefundMutation();
  const [cancelledOfferMembers] = useLazyGetCancelledOfferMembersQuery();

  const goBack = () => {
    navigate(-1);
  };

  const [data, setData] = useState<CancelledMemberType[]>([]);
  const [loading, setLoading] = useState(false);

  const [amounts, setAmounts] = useState<Record<string, string>>({});

  const RefundEventApi = async () => {
    try {
      setLoading(true);
      const body = {
        offerId,
        refundUsers: data?.map((row) => ({
          email: row?.user?.email || "",
          amount: amounts[row?.id] || "",
          role: row?.role || "",
        })),
      };

      const response = await eventRefundApi(body).unwrap();
      setLoading(false);

      if (response.status === 200) {
        showToast(response?.message || "");
        goBack();
      }
    } catch (error: any) {
      setLoading(false);
      showError(error?.data?.message || "");
    }
  };

  const getCancelledOfferMembers = async () => {
    try {
      const response = await cancelledOfferMembers({
        offerId: offerId,
        search: "",
      }).unwrap();

      if (response.status === 200) {
        setData(response?.data || []);

        if (response?.data?.length) {
          const initialAmounts: Record<string, string> = {};
          response?.data?.forEach((row: any) => {
            initialAmounts[row?.id] =
              row?.amount !== undefined ? String(row?.amount) : "";
          });
          setAmounts(initialAmounts);
        }
      }
    } catch (error: any) {
      showError(error?.data?.message || "");
    }
  };

  useEffect(() => {
    getCancelledOfferMembers();
  }, []);

  return (
    <MainContainer>
      <Loader isLoad={loading} />
      <div className="main_title d_flex">
        <div className="left_s">
          <h1 className="back_arrow">
            <IconButton onClick={goBack}>
              <ArrowBackIcon />
            </IconButton>{" "}
            User listing
          </h1>
        </div>

        <div className="right_s">
          <Button className="btn btn_primary" onClick={RefundEventApi}>
            Refund Amount
          </Button>
        </div>
      </div>

      <div className="sorting_table cards table_cards">
        <div className="table_container">
          <table
            style={{
              width: "100%",
              borderCollapse: "collapse",
              tableLayout: "fixed",
            }}
          >
            <thead>
              <tr>
                <th>Name</th>
                <th>Email</th>
                <th>Membership Type</th>
                <th>Booking Date & Time</th>
                <th>Price</th>
              </tr>
            </thead>
            <tbody>
              {data?.length
                ? data?.map((row) => (
                  <tr key={row?.id}>
                    <td>
                      <div className="user_block click_action">
                        <figure>
                          <img
                            src="/static/images/user_placeholder.png"
                            alt=""
                          />
                        </figure>
                        <p>
                          <b>{row?.user?.name || "-"}</b>
                        </p>
                      </div>
                    </td>
                    <td>{row?.user?.email || "-"}</td>
                    <td>{row?.role || "-"}</td>
                    <td>{row?.role || "-"}</td>
                    <td>
                      <div className="control_group enter_amount">
                        <TextField
                          type="text"
                          placeholder="Amount"
                          hiddenLabel
                          fullWidth
                          inputProps={{ maxLength: 10 }}
                          value={amounts[row?.id] ?? ""}
                          onChange={(e) => {
                            let value = e.target.value.replace(/[^0-9]/g, "");
                            setAmounts((prev) => ({
                              ...prev,
                              [row?.id]: value,
                            }));
                          }}
                        />
                      </div>
                    </td>
                  </tr>
                ))
                : null}
            </tbody>
          </table>
        </div>
      </div>
    </MainContainer>
  );
};

export default Userlist;
